import { render } from "./index.vue?vue&type=template&id=5850179f&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Layouts/TopHeader/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5850179f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5850179f', __exports__)) {
    api.reload('5850179f', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=5850179f&ts=true", () => {
    api.rerender('5850179f', render)
  })

}


export default __exports__